import styled from 'styled-components';

// Full page cover. It will cover everything on the page with a white screen, and also center it's content.
export const PageCover = styled.div.attrs((props) => ({
  'data-test-class': 'page-cover',
}))`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.75);
  z-index: 100;
`;
